"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTMDBData = exports.getTMDBExternalImdbId = exports.getTMDBMovieImdbId = exports.setTMDBApiKey = exports.getTMDBApiKey = void 0;
var STORAGE_KEY = 'stremio_tmdb_api_key';
var API_BASE_URL = 'https://api.themoviedb.org/3';
var getTMDBApiKey = function () {
    try {
        return window.localStorage.getItem(STORAGE_KEY);
    }
    catch (error) {
        console.error('Failed to get TMDB API key:', error);
        return null;
    }
};
exports.getTMDBApiKey = getTMDBApiKey;
var setTMDBApiKey = function (key) {
    try {
        window.localStorage.setItem(STORAGE_KEY, key);
    }
    catch (error) {
        console.error('Failed to set TMDB API key:', error);
    }
};
exports.setTMDBApiKey = setTMDBApiKey;
var fetchTMDBId = function (imdbId, apiKey, type) { return __awaiter(void 0, void 0, Promise, function () {
    var findUrl, response, data, results;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                findUrl = "".concat(API_BASE_URL, "/find/").concat(imdbId, "?api_key=").concat(apiKey, "&external_source=imdb_id");
                return [4 /*yield*/, fetch(findUrl, {
                        method: 'GET',
                        headers: { 'accept': 'application/json' }
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                results = type === 'movie' ? data.movie_results : data.tv_results;
                return [2 /*return*/, results && results.length > 0 ? results[0].id : null];
        }
    });
}); };
var fetchTMDBDetails = function (tmdbId, apiKey, type) { return __awaiter(void 0, void 0, Promise, function () {
    var appendParams, url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                appendParams = type === 'movie'
                    ? 'credits,release_dates,similar,recommendations,collection'
                    : 'credits,content_ratings,similar,recommendations';
                url = "".concat(API_BASE_URL, "/").concat(type, "/").concat(tmdbId, "?api_key=").concat(apiKey, "&append_to_response=").concat(appendParams, "&language=en-US");
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: { 'accept': 'application/json' }
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var fetchTMDBCollection = function (collectionId, apiKey) { return __awaiter(void 0, void 0, Promise, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(API_BASE_URL, "/collection/").concat(collectionId, "?api_key=").concat(apiKey, "&language=en-US");
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: { 'accept': 'application/json' }
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getTMDBMovieImdbId = function (tmdbMovieId, apiKey) { return __awaiter(void 0, void 0, Promise, function () {
    var url, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(API_BASE_URL, "/movie/").concat(tmdbMovieId, "/external_ids?api_key=").concat(apiKey);
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: { 'accept': 'application/json' }
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, typeof data.imdb_id === 'string' && data.imdb_id.length > 0 ? data.imdb_id : null];
        }
    });
}); };
exports.getTMDBMovieImdbId = getTMDBMovieImdbId;
var getTMDBExternalImdbId = function (tmdbId, type, apiKey) { return __awaiter(void 0, void 0, Promise, function () {
    var url, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(API_BASE_URL, "/").concat(type, "/").concat(tmdbId, "/external_ids?api_key=").concat(apiKey);
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: { 'accept': 'application/json' }
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, typeof data.imdb_id === 'string' && data.imdb_id.length > 0 ? data.imdb_id : null];
        }
    });
}); };
exports.getTMDBExternalImdbId = getTMDBExternalImdbId;
var transformTMDBData = function (data, collectionParts) {
    var _a, _b, _c, _d, _e, _f;
    var maturityRating = null;
    if ('release_dates' in data && ((_a = data.release_dates) === null || _a === void 0 ? void 0 : _a.results)) {
        var usRelease = data.release_dates.results.find(function (r) { return r.iso_3166_1 === 'US'; });
        if (usRelease === null || usRelease === void 0 ? void 0 : usRelease.release_dates) {
            var theatrical = usRelease.release_dates.find(function (rd) { return rd.type === 3 && rd.certification && rd.certification.length > 0; });
            if (theatrical) {
                maturityRating = theatrical.certification;
            }
            else {
                var anyWithCert = usRelease.release_dates.find(function (rd) { return rd.certification && rd.certification.length > 0; });
                maturityRating = (anyWithCert === null || anyWithCert === void 0 ? void 0 : anyWithCert.certification) || null;
            }
        }
    }
    else if ('content_ratings' in data && ((_b = data.content_ratings) === null || _b === void 0 ? void 0 : _b.results)) {
        var usRating = data.content_ratings.results.find(function (r) { return r.iso_3166_1 === 'US'; });
        maturityRating = (usRating === null || usRating === void 0 ? void 0 : usRating.rating) || null;
    }
    return {
        cast: ((_d = (_c = data.credits) === null || _c === void 0 ? void 0 : _c.cast) === null || _d === void 0 ? void 0 : _d.slice(0, 20)) || [],
        maturityRating: maturityRating,
        collection: 'belongs_to_collection' in data ? data.belongs_to_collection : null,
        collectionParts: collectionParts,
        similar: ((_e = data.similar) === null || _e === void 0 ? void 0 : _e.results) || [],
        recommendations: ((_f = data.recommendations) === null || _f === void 0 ? void 0 : _f.results) || [],
        overview: typeof data.overview === 'string' && data.overview.length > 0 ? data.overview : null,
    };
};
var getTMDBData = function (imdbId_1, apiKey_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([imdbId_1, apiKey_1], args_1, true), Promise, function (imdbId, apiKey, type, options) {
        var tmdbId, details, collectionParts, includeCollectionParts, collection, error_1;
        var _a;
        if (type === void 0) { type = 'movie'; }
        if (options === void 0) { options = {}; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!imdbId || !apiKey) {
                        return [2 /*return*/, null];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, fetchTMDBId(imdbId, apiKey, type)];
                case 2:
                    tmdbId = _b.sent();
                    if (!tmdbId) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, fetchTMDBDetails(tmdbId, apiKey, type)];
                case 3:
                    details = _b.sent();
                    if (!details) {
                        return [2 /*return*/, null];
                    }
                    collectionParts = [];
                    includeCollectionParts = options.includeCollectionParts !== false;
                    if (!(includeCollectionParts && type === 'movie' && 'belongs_to_collection' in details && ((_a = details.belongs_to_collection) === null || _a === void 0 ? void 0 : _a.id))) return [3 /*break*/, 5];
                    return [4 /*yield*/, fetchTMDBCollection(details.belongs_to_collection.id, apiKey)];
                case 4:
                    collection = _b.sent();
                    if (collection === null || collection === void 0 ? void 0 : collection.parts) {
                        collectionParts = collection.parts;
                    }
                    _b.label = 5;
                case 5: return [2 /*return*/, transformTMDBData(details, collectionParts)];
                case 6:
                    error_1 = _b.sent();
                    console.error('Failed to fetch TMDB data:', error_1);
                    return [2 /*return*/, null];
                case 7: return [2 /*return*/];
            }
        });
    });
};
exports.getTMDBData = getTMDBData;
